import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import { apiUrl } from './index';

export default {
  // Get
  getAdvertisers(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_advertisers`,
      params,
    });
  },
  getProgram({ advertiserId, programId }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_advertisers/${advertiserId}/programs/${programId}`,
    });
  },
  getPrograms(advertiserId) {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_advertisers/${advertiserId}/programs`,
    });
  },
  getDomains(advertiserId) {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_advertisers/${advertiserId}/domains`,
    });
  },
  checkIfCountryIsLinkedToDomain({ advertiserId, country }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_advertisers/${advertiserId}/domains/${country}`,
    });
  },
  getAdvertiser(id) {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_advertisers/${id}`,
    });
  },
  getProgramStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_programs/statuses`,
    });
  },
  getProgramTags() {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_programs/tags`,
    });
  },
  getTrafficNetworks(query = {}) {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_networks`,
      params: query,
    });
  },
  getTrafficNetworkTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_networks/types`,
    });
  },
  getTrafficNetwork(id) {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_networks/${id}`,
    });
  },
  getComboTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_combos/types`,
    });
  },
  checkIfThereIsActiveProgram({ advertiserId, query = {} }) {
    // ?country=DE&program_id=3
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_advertisers/${advertiserId}/programs/active`,
      params: query,
    });
  },
  getFilterStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_programs/filter_statuses`,
    });
  },
  getPreviewLink(params) {
    return axios({
      method: 'post',
      url: `${apiUrl}/clicky_programs/preview_link`,
      params,
    });
  },

  // Create
  createTrafficNetwork(data) {
    return axios({
      method: 'post',
      url: `${apiUrl}/clicky_networks`,
      data,
    });
  },
  createNetworkCredentials({ network_id, ...credentials }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/clicky_networks/${network_id}/credentials`,
      data: {
        ...credentials,
      },
    });
  },
  createAdvertiser(advertiser) {
    return axios({
      method: 'post',
      url: `${apiUrl}/clicky_advertisers`,
      data: {
        ...advertiser,
      },
    });
  },
  createDomain({ domain, advertiserId }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/clicky_advertisers/${advertiserId}/domains`,
      data: {
        ...domain,
      },
    });
  },
  createProgram({ program, advertiserId }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/clicky_advertisers/${advertiserId}/programs`,
      data: {
        ...program,
      },
    });
  },

  updateNetworkCredentials({ network_id, credential_id, ...credentials }) {
    return axios({
      method: 'put',
      url: `${apiUrl}/clicky_networks/${network_id}/credentials/${credential_id}`,
      data: {
        ...credentials,
      },
    });
  },

  // Update
  updateTrafficNetwork({ id, ...data }) {
    return axios({
      method: 'put',
      url: `${apiUrl}/clicky_networks/${id}`,
      data,
    });
  },
  getNetworkCredentials(networkId) {
    return axios({
      method: 'get',
      url: `${apiUrl}/clicky_networks/${networkId}/credentials`,
    });
  },
  updateAdvertiser(advertiser) {
    return axios({
      method: 'put',
      url: `${apiUrl}/clicky_advertisers/${advertiser.id}`,
      data: {
        ...advertiser,
      },
    });
  },
  updateDomain({ domain, advertiserId, domainId }) {
    return axios({
      method: 'put',
      url: `${apiUrl}/clicky_advertisers/${advertiserId}/domains/${domainId}`,
      data: {
        ...domain,
      },
    });
  },
  updateProgram({ program, advertiserId, programId }) {
    return axios({
      method: 'put',
      url: `${apiUrl}/clicky_advertisers/${advertiserId}/programs/${programId}`,
      data: {
        ...program,
      },
    });
  },

  // Delete
  deleteNetworkCredentials({ network_id, credential_id }) {
    return axios({
      method: 'delete',
      url: `${apiUrl}/clicky_networks/${network_id}/credentials/${credential_id}`,
    });
  },
  deleteDomain({ domainId, advertiserId }) {
    return axios({
      method: 'delete',
      url: `${apiUrl}/clicky_advertisers/${advertiserId}/domains/${domainId}`,
    });
  },

  // Upload
  bulkUploadPrograms({ file }) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const fd = new FormData();

    fd.append('file', file);
    return axios.post(`${apiUrl}/clicky_programs/upload`, fd, config);
  },
};
